import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { updateServiceworker } from './actions';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';

import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

import reducers from './reducers';

import posthog from 'posthog-js';
import { PostHogProvider, PostHogErrorBoundary } from '@posthog/react';

// api_host is our own /ingest reverse proxy in production (see index.js);
// ui_host keeps toolbar/links pointing at PostHog itself
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  ui_host: 'https://us.posthog.com',
  defaults: '2026-01-30',
});

// dev (localhost) and prod share one PostHog project, so tag every event
// with the build environment to keep them separable. NODE_ENV is baked in
// at build time by CRA ('development' locally, 'production' on Railway).
posthog.register({ environment: process.env.NODE_ENV });

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(reduxThunk))
);

const onUpdate = () => {
  store.dispatch(updateServiceworker());
  console.log('service worker updated');
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </PostHogErrorBoundary>
  </PostHogProvider>
);

registerServiceWorker(onUpdate);
